import { useEffect, useState } from 'react';
import { AuthService } from '../../../services/auth.service';
import { ManagedDashboardService } from '../../../services/managedDashboard.service';

/**
 * True when the caller has at least one role and one department they may set a default for. A department head
 * (MANAGE_TEAM without MANAGE_ALL) who heads nothing has nothing to edit, so the launcher hides "Role defaults".
 * Pass `active=false` for callers who do not need the answer: no request is made.
 */
export default function useHasDefaultTargets(active: boolean): boolean {
    const institutionId = AuthService.getSelectedInstitution() ?? '';
    const [has, setHas] = useState(false);
    useEffect(() => {
        if (!active || !institutionId) { setHas(false); return; }
        let live = true;
        ManagedDashboardService.targets(institutionId)
            .then(t => { if (live) setHas((t.departments ?? []).length > 0 && (t.roles ?? []).length > 0); })
            .catch(() => { if (live) setHas(false); });
        return () => { live = false; };
    }, [active, institutionId]);
    return has;
}
